import { IUsersInfo } from '@monetize/types/app';
import { sortTeamUsers } from '../../utils/settings';
import { MAvatar, MTooltip } from '../Monetize';

type MemberAvatarProps = {
  members: IUsersInfo[];
  owner: string;
};

/**
 Display user avatars
*/

export const MemberAvatar = ({ members, owner }: MemberAvatarProps) => {
  return (
    <>
      {sortTeamUsers(members, owner).map(({ name, id }) => (
        <MTooltip label={name} shouldWrapChildren key={id}>
          <MAvatar key={id} name={name} mr="2" width={'25px'} height={'25px'} />
        </MTooltip>
      ))}
    </>
  );
};
